import Vue from 'vue'
import Vuex from 'vuex'
import filterMessages from '@/components/Filter/i18n'

Vue.use(Vuex)

export const LANGUAGE_KEY = 'APP_LANGUAGE'

const mergeMessages = (base, moduleMessages) => ({
  ...base,
  common: {
    ...base.common,
    ...(moduleMessages.common || {})
  }
})

export const messages = {
  zh: mergeMessages({
    // zh 块：每个 key 的 value 即中文 label（搜中文时直接命中）
    common: {
      chinese: '中文',
      english: 'English',
      switchLanguage: '切换语言',
      home: '首页',
      login: '登录',
      logout: '退出登录',
      personalCenter: '个人中心',
      changePassword: '修改密码',
      userMessage: '用户留言',
      clippingTool: '下载剪报工具',
      compactDiscTool: '下载子光盘工具',
      mainMenu: '主菜单',
      loading: '拼命加载中',
      noData: '暂无数据',
      confirm: '确定',
      cancel: '取消',
      search: '搜索',
      searchInResults: '结果中检索',
      searchField: '检索字段',
      pageName: '版名',
      edition: '版次',
      issueNumber: '期号',
      sourceField: '文章来源',
      column: '栏目',
      paperName: '报刊名称',
      layoutType: '版面类型',
      normalLayout: '正常',
      jointLayout: '连版/通版',
      excludeSearch: '结果中排除检索',
      reset: '重置',
      export: '导出',
      selectContent: '请选择内容',
      inputContent: '请输入内容',
      selectCategory: '请点击选择分类内容',
      inputPageName: '请输入版名',
      selectPageNo: '请选择版次',
      selectAiCategory: '请点击选择AI分类',
      startDate: '开始日期',
      endDate: '结束日期',
      publishDate: '出版日期',
      dateSort: '日期排序',
      contentFilter: '内容筛选',
      deduplicate: '去重',
      traditionalSwitch: '繁体检索',
      simplified: '简体',
      traditional: '繁体',
      sameWord: '同义词扩展',
      oppositeWord: '反义词扩展',
      to: '至',
      advancedSearch: '高级检索',
      semanticSearch: '语义检索',
      semanticImageSearch: '语义搜图',
      pageSearch: '版面检索',
      fullLibrary: '全库检索',
      articleSearch: '文章检索',
      photoSearch: '图片检索',
      adSearch: '广告检索',
      censusSearch: '检索统计',
      featureList: '专题列表',
      imageProcess: '图片处理',
      source: '报刊名称',
      detail: '细览页面',
      imageDetail: '图片细览页',
      journalDetail: '期刊详情',
      journalBrowse: '期刊浏览',
      article: '文章',
      image: '图片',
      ad: '广告',
      title: '标题',
      author: '作者',
      content: '内容',
      body: '正文',
      titleContent: '标题+内容',
      aiSummary: 'AI摘要',
      default: '默认',
      ascending: '升序',
      descending: '降序',
      relatedness: '相关度排序',
      dateDescending: '日期降序',
      dateAscending: '日期升序',
      yes: '是',
      no: '否',
      total: '共 {count} 条',
      subHeading: '分目',
      entry: '条目',
      journalName: '杂志名',
      totalIssueNumber: '总期号',
      imageSubjects: '图片人物',
      editor: '编辑',
      adClassification: '广告分类',
      adSecondHandProperty: '二手房',
      adClassifieds: '分类广告',
      adHomeImprovement: '家装',
      adPublicService: '公益广告',
      adAutomotive: '汽车',
      adHealthcare: '医疗药品',
      adRealEstate: '房地产',
      adTravel: '旅游',
      adFinance: '金融',
      adFoodAndConsumer: '食品·消费',
      adCultureAndEntertainment: '文化娱乐',
      adEducationAndTraining: '教育培训',
      adExhibitions: '展销展会',
      adEvents: '活动',
      adPublic: '公共',
      adSpecialTopic: '专题',
      statTotalRecords: '统计总记录数',
      statArticleCount: '统计文章篇数',
      statPictureCount: '统计图片数量',
      statAdCount: '统计广告数量',
      totalRecords: '总记录数',
      articleCount: '文章篇数',
      pictureCount: '图片数量',
      adCount: '广告数量',
      downloadSelectedRecords: '下载选中的记录',
      downloadTitleList: '下载标题列表',
      downloadSelectedPdf: '下载选中的 PDF',
      directExport: '直接导出',
      statistics: '统计',
      index: '序号',
      actions: '操作',
      downloadPdf: '下载 PDF',
      sort: '排序',
      type: '类型',
      attrSuffix: '属性',
      totalPrefix: '共找到 ',
      batchExport: '批量导出',
      importTopic: '引入专题',
      editionCount: '版数',
      dateColumn: '日期',
      exportFilePrefix: '统计',
      wordCount: '文章字数',
      aiArticleCategory: 'AI 文章分类',
      aiArticleGenre: 'AI 文章体裁',
      aiRegion: 'AI 地区',
      aiTopic: 'AI 专题',
      aiArticleSummary: 'AI 文章摘要',
      imageGenre: '图片体裁',
      imageSource: '图片来源',
      imageAuthor: '图片作者',
      imageCaption: '图片说明',
      imageCopyright: '图片版权归属',
      region: '地区',
      adKeyword: '广告关键词',
      adColor: '广告色彩',
      adType: '广告类型',
      statWayYear: '按年统计',
      statWayMonth: '按月统计',
      statWayDay: '按日统计',
      statEditionCount: '统计版数',
      adBlackWhite: '黑白广告',
      adAccentRed: '套红广告',
      adFullColor: '彩色广告',
      adCommercial: '工商广告',
      adColumnBanner: '栏花广告',
      adColumnSpecial: '专栏广告',
      editionUnit: '版',
      imageUnit: '张',
      recordsUnit: '条',
      downloadArticleRecords: '文章_',
      downloadArticleTitles: '文章标题_',
      downloadArticlePdf: '下载pdf_'
    },
    login: {
      username: '账号',
      password: '密码',
      captcha: '验证码',
      usernamePlaceholder: '请输入账号',
      passwordPlaceholder: '请输入登录密码',
      captchaPlaceholder: '请输入验证码',
      submit: '登 录',
      length: '长度在 {min} 到 {max} 个字符',
      captchaError: '验证码错误！'
    }
  }, filterMessages.zh),
  en: mergeMessages({
    common: {
      chinese: '中文',
      english: 'English',
      switchLanguage: 'Language',
      home: 'Home',
      login: 'Log in',
      logout: 'Log out',
      personalCenter: 'Account',
      changePassword: 'Change password',
      userMessage: 'User messages',
      clippingTool: 'Download clipping tool',
      compactDiscTool: 'Download disc tool',
      mainMenu: 'Main menu',
      loading: 'Loading',
      noData: 'No data',
      confirm: 'Confirm',
      cancel: 'Cancel',
      search: 'Search',
      searchInResults: 'Search within results',
      searchField: 'Search field',
      pageName: 'Page name',
      edition: 'Edition',
      issueNumber: 'Issue number',
      sourceField: 'Source',
      column: 'Column',
      paperName: 'Publication',
      layoutType: 'Layout type',
      normalLayout: 'Normal',
      jointLayout: 'Joint layout',
      deduplicate: 'Deduplicate',
      excludeSearch: 'Exclude from results',
      reset: 'Reset',
      export: 'Export',
      selectContent: 'Select content',
      inputContent: 'Enter content',
      selectCategory: 'Click to select a category',
      inputPageName: 'Enter page name',
      selectPageNo: 'Select edition',
      selectAiCategory: 'Click to select an AI category',
      startDate: 'Start date',
      endDate: 'End date',
      publishDate: 'Publication date',
      dateSort: 'Date sort',
      contentFilter: 'Content filter',
      traditionalSwitch: 'Traditional Chinese',
      simplified: 'Simplified',
      traditional: 'Traditional',
      sameWord: 'Synonym expansion',
      oppositeWord: 'Antonym expansion',
      to: 'to',
      advancedSearch: 'Advanced search',
      semanticSearch: 'Semantic search',
      semanticImageSearch: 'Semantic image search',
      pageSearch: 'Page search',
      fullLibrary: 'Full library',
      articleSearch: 'Article search',
      photoSearch: 'Image search',
      adSearch: 'Ad search',
      censusSearch: 'Search statistics',
      featureList: 'Topics',
      imageProcess: 'Image processing',
      source: 'Historical sources',
      detail: 'Article details',
      imageDetail: 'Image details',
      journalDetail: 'Periodical details',
      journalBrowse: 'Periodical browser',
      article: 'Article',
      image: 'Image',
      ad: 'Advertisement',
      title: 'Title',
      author: 'Author',
      content: 'Content',
      body: 'Body',
      titleContent: 'Title + content',
      aiSummary: 'AI summary',
      default: 'Default',
      ascending: 'Ascending',
      descending: 'Descending',
      relatedness: 'Relevance',
      dateDescending: 'Date descending',
      dateAscending: 'Date ascending',
      yes: 'Yes',
      no: 'No',
      total: '{count} results',
      subHeading: 'Subheading',
      entry: 'Entry',
      journalName: 'Publication title',
      totalIssueNumber: 'Cumulative issue number',
      imageSubjects: 'People depicted',
      editor: 'Editor',
      adClassification: 'Advertising category',
      adSecondHandProperty: 'Second-hand property',
      adClassifieds: 'Classified advertising',
      adHomeImprovement: 'Home improvement',
      adPublicService: 'Public service',
      adAutomotive: 'Automotive',
      adHealthcare: 'Healthcare and pharmaceuticals',
      adRealEstate: 'Real estate',
      adTravel: 'Travel',
      adFinance: 'Finance',
      adFoodAndConsumer: 'Food and consumer goods',
      adCultureAndEntertainment: 'Culture and entertainment',
      adEducationAndTraining: 'Education and training',
      adExhibitions: 'Exhibitions and trade fairs',
      adEvents: 'Events',
      adPublic: 'Public affairs',
      adSpecialTopic: 'Special topics',
      statTotalRecords: 'Total records',
      statArticleCount: 'Article count',
      statPictureCount: 'Image count',
      statAdCount: 'Advertising count',
      totalRecords: 'Total records',
      articleCount: 'Articles',
      pictureCount: 'Images',
      adCount: 'Advertisements',
      downloadSelectedRecords: 'Download selected records',
      downloadTitleList: 'Download title list',
      downloadSelectedPdf: 'Download selected PDF',
      directExport: 'Export directly',
      statistics: 'Statistics',
      index: 'No.',
      actions: 'Actions',
      downloadPdf: 'Download PDF',
      sort: 'Sort',
      type: 'Type',
      attrSuffix: 'properties',
      totalPrefix: 'Total: ',
      batchExport: 'Bulk export',
      importTopic: 'Add to topic',
      editionCount: 'Editions',
      dateColumn: 'Date',
      exportFilePrefix: 'Statistics_',
      wordCount: 'Word count',
      aiArticleCategory: 'AI article category',
      aiArticleGenre: 'AI article genre',
      aiRegion: 'AI region',
      aiTopic: 'AI topic',
      aiArticleSummary: 'AI article summary',
      imageGenre: 'Image genre',
      imageSource: 'Image source',
      imageAuthor: 'Image author',
      imageCaption: 'Image caption',
      imageCopyright: 'Image copyright',
      region: 'Region',
      adKeyword: 'Ad keyword',
      adColor: 'Ad color',
      adType: 'Ad type',
      statWayYear: 'By year',
      statWayMonth: 'By month',
      statWayDay: 'By day',
      statEditionCount: 'Editions',
      adBlackWhite: 'Black and white',
      adAccentRed: 'Red-tinted',
      adFullColor: 'Full color',
      adCommercial: 'Commercial',
      adColumnBanner: 'Column banner',
      adColumnSpecial: 'Column sponsored',
      editionUnit: 'editions',
      imageUnit: 'images',
      recordsUnit: 'records',
      downloadArticleRecords: 'Articles_',
      downloadArticleTitles: 'Article_titles_',
      downloadArticlePdf: 'Download_pdf_'
    },
    login: {
      username: 'Username',
      password: 'Password',
      captcha: 'Captcha',
      usernamePlaceholder: 'Enter username',
      passwordPlaceholder: 'Enter password',
      captchaPlaceholder: 'Enter captcha',
      submit: 'Log in',
      length: '{min} to {max} characters',
      captchaError: 'Incorrect captcha!'
    }
  }, filterMessages.en)
}

function normalizeLanguage(language) {
  return String(language || '').toLowerCase().startsWith('en') ? 'en' : 'zh'
}

function getInitialLanguage() {
  return normalizeLanguage(window.localStorage.getItem(LANGUAGE_KEY))
}

const state = Vue.observable({ language: getInitialLanguage() })

const i18n = {
  get language() {
    return state.language
  },
  t(key, params = {}) {
    const parts = key.split('.')
    let value = messages[state.language]
    parts.forEach((part) => {
      value = value && value[part]
    })
    if (typeof value !== 'string') return key
    return value.replace(/\{(\w+)\}/g, (_, name) => params[name] === undefined ? `{${name}}` : params[name])
  },
  setLanguage(language) {
    state.language = normalizeLanguage(language)
    window.localStorage.setItem(LANGUAGE_KEY, state.language)
  }
}

Vue.prototype.$t = function (key, params) {
  return i18n.t(key, params)
}
Vue.prototype.$language = i18n

export default i18n
